export const hoverCards = () => {
  const navItems = document.querySelectorAll('.menu-link');
  function getClicked() {
    navItems.forEach(el => {
      el.classList.remove('active')
      el.classList.add('grey')
    });
    this.classList.remove('grey')
    this.classList.add('active');
  }

  function offClicked() {
    navItems.forEach(el => {
      el.classList.add('white')
      el.classList.remove('grey')
    });
  }
  if (window.innerWidth >= 1200 && navItems) {
    navItems.forEach(el => {
      el.addEventListener('mouseover', getClicked)
    });
    navItems.forEach(el => {
      el.addEventListener('mouseout', offClicked)
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/components/js-component/hover-cards.js